registerComponent("pages/product-internal", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Quatro coisas, as mesmas de 2020: o botão "quero investir" que abre o
 * `modals/modal-investir`, o botão flutuante que aparece depois do hero, o menu
 * de categorias do breadcrumb e o `top` do overlay dele no `resize`. O submenu
 * dos blocos era o bloco `body.menu-fixed` do `legacy-main.js` mais uma página
 * por item, e hoje é `Asa.legado.submenuAncorado`.
 *
 * ⚠️ `$modalInvestir.trigger('open', [attributes])` → `CustomEvent('open',
 * { detail })`, o MESMO contrato que `blocks/card-product` já emite desde o
 * sub-lote 5d, com os mesmos oito atributos lidos por `Asa.legado.dado()` — que
 * devolve número onde o jQuery devolvia número. Sem isso o modal abre com
 * `minAplication` em string e o `toLocaleString` de moeda sai sem símbolo e sem
 * centavos, calado. Os dois caminhos (cartão da listagem e botão da página) têm
 * de ser testados.
 *
 * ⚠️ `$('...')` era o documento inteiro, não o componente: o
 * `modals/modal-investir` é irmão deste componente no Blade, não descendente.
 */

const hero = document.querySelector('[data-component-name="sections/hero"]');
const modalInvestir = document.querySelector('[data-component-name="modals/modal-investir"]');
const botaoCategoria = component.querySelector('.breadcrumb-category');
const menuCategorias = component.querySelector('.category-menu');
const overlay = component.querySelector('.wrapper-categories-overlay');
const cabecalhoDoFundo = component.querySelector('.product-header');

component.querySelectorAll('[data-open-modal]').forEach(function (botao) {
    botao.addEventListener('click', function () {
        if (!modalInvestir) {
            return;
        }

        modalInvestir.dispatchEvent(new CustomEvent('open', {
            detail: {
                aditionalAplication: Asa.legado.dado(botao, 'aditional-aplication'),
                minAplication: Asa.legado.dado(botao, 'min-aplication'),
                minBalance: Asa.legado.dado(botao, 'min-balance'),
                platforms: Asa.legado.dado(botao, 'platforms'),
                productName: Asa.legado.dado(botao, 'product-name'),
                productUrl: Asa.legado.dado(botao, 'product-url'),
                // `$this.data('institucional') ? true : false` de 2020. Este
                // Blade nunca emite o atributo (só o do `card-product` emite),
                // então aqui é sempre `false` — o modal institucional se abre
                // pela listagem.
                isInstitucional: Boolean(Asa.legado.dado(botao, 'institucional')),
            },
        }));
    });
});

/*
 | O botão flutuante: aparece depois que a página passa da altura do hero.
 |
 | A altura é medida UMA vez, no boot, como em 2020 (`const screenSize =
 | $hero.offsetHeight`) — e não a cada quadro. O `window.dispatchEvent(new
 | CustomEvent('scroll'))` que o legado disparava no fim para avaliar a posição
 | inicial não é preciso: `Asa.aoRolar` chama o inscrito de imediato.
 */
const alturaDoHero = hero ? hero.offsetHeight : 0;

Asa.aoRolar(function (y) {
    component.classList.toggle('show-btn', y > alturaDoHero);
});

/*
 | O menu de categorias. Em 2020 eram três `.toggleClass('active')` numa coleção
 | montada com `.add()`; aqui é a mesma lista, explícita.
 */
const pecasDoMenu = [menuCategorias, overlay, botaoCategoria].filter(Boolean);

if (botaoCategoria) {
    botaoCategoria.addEventListener('click', function () {
        pecasDoMenu.forEach(function (peca) {
            peca.classList.toggle('active');
        });

        Asa.track('menu_toggle', { target_id: 'fund_categories', state: botaoCategoria.classList.contains('active') ? 'open' : 'close' });
    });
}

if (overlay) {
    overlay.addEventListener('click', function () {
        pecasDoMenu.forEach(function (peca) {
            peca.classList.remove('active');
        });
    });

    /*
     | O `top` do overlay, que é `position: absolute` no documento: o `.offset()
     | .top` do jQuery é a caixa do elemento SOMADA ao que já se rolou.
     |
     | ⚠️ Só no `resize`, como em 2020 — no primeiro render o overlay fica em
     | `top: 0`. Não é esquecimento da transposição: o `$window.on('resize')`
     | legado também não tinha `.trigger('resize')` no fim, ao contrário do
     | bloco de rolagem logo acima dele, que tinha.
     */
    window.addEventListener('resize', function () {
        if (cabecalhoDoFundo) {
            overlay.style.top = `${window.scrollY + cabecalhoDoFundo.getBoundingClientRect().top}px`;
        }
    });
}

/*
 | O submenu dos blocos do fundo: a MESMA peça de `pages/products-list`
 | (menu preso, item ativo pela rolagem, rolagem suave até a âncora e o select
 | do celular). Em 2020 cada item era uma página — `…/asa-hedge/rentabilidade/`
 | recarregava tudo e `Asa.legado.ancoras()` rolava até o `data-url`; hoje é
 | `…/asa-hedge#rentabilidade`, e o segmento antigo responde 301 para a âncora.
 */
Asa.legado.submenuAncorado(component, {
    secoes: '[data-component-name^="product-blocks/"][id]',
});

});
